import React, { useState, useReducer, useContext, useRef } from 'react';
import AddressTextField from '../../../UI/AddressTextField';
import AddressSelectBox from '../../../UI/AddressSelectBox';
import { usePostCodeAddress } from '../../../../Hooks/usePostCodeAddress';
import VisitorParamsContext from '../../../../Contexts/VisitorParams';
import Button from '../../../UI/Button';
import GTMDataLayer from '../../../../Utility/GTMDataLayer';

const initialState = {
	lookUp: true,
	nextClick: false,
	checkSelect: false,
	getDetails: [],
	getAddress: [],
	showManualAddress: 'hide',
	getPostcode: '#',
};
const postcodeReducer = (state, action) => {
	switch (action.type) {
		case 'validationSucess': {
			return {
				...state,
				lookUp: action.payload.lookup,
				nextClick: action.payload.next_click,
				getPostcode: action.payload.postcode,
				getAddress: action.payload.get_address,
				checkSelect: action.payload.check_select,
				showManualAddress: action.payload.manual_address,
			};
		}
		case 'getExtraAddressDetails': {
			return {
				...state,
				getDetails: action.payload.get_details,
				showManualAddress: action.payload.manual_address,
			};
		}
		case 'showManualDiv': {
			return {
				...state,
				showManualAddress: 'show',
				lookUp: false,
				nextClick: true,
				checkSelect: false,
				clickManualLink: action.payload.manual_click,
			};
		}
		case 'resetaddress': {
			return {
				...state,
				getDetails: [],
				getAddress: [],
				showManualAddress: 'hide',
				lookUp: true,
				nextClick: false,
				checkSelect: false,
			};
		}
		default:
			return state;
	}
};

const Postcode = (props) => {
	const { getPostcodeAddress, getSplitPostcodeAddress } =
		usePostCodeAddress();
	const [state, dispatch] = useReducer(postcodeReducer, initialState);
	const { visitorParameters } = useContext(VisitorParamsContext);
	const scrollToEvent = useRef(null);
	const checkValidation = async (e) => {
		e.preventDefault();
		dispatch({
			type: 'resetaddress',
			get_address: [],
		});
		const txtPostCode = await props.trigger('txtPostCode');

		if (txtPostCode) {
			await getPostcodeAddress(
				e.target.value,
				visitorParameters.visitor_parameters.uuid
			)
				.then((res) => {
					if (res.data.status === '0') {
						props.setError('txtPostCode', {
							type: 'manual',
							message: 'Please Enter Valid Postcode',
						});
					}
					if (res.data.length > 0) {
						dispatch({
							type: 'validationSucess',
							payload: {
								lookup: false,
								next_click: true,
								postcode: e.target.value,
								get_address: res.data,
								check_select: true,
								manual_address: 'hide',
							},
						});
					}
				})
				.catch(function () {
					props.setError('txtPostCode', {
						type: 'manual',
						message: 'Please Enter Valid Postcode',
					});
				});
		}
	};
	const getValue = async (e) => {
		e.preventDefault();
		dispatch({
			type: 'getExtraAddressDetails',
			payload: { get_details: [], manual_address: 'hide' },
		});
		props.clearErrors([
			'txtHouseNumber',
			'txtAddress3',
			'txtCounty',
			'txtTown',
			'txtCountry',
		]);
		if (e.target.value != '') {
			const getData = await getSplitPostcodeAddress(
				e.target.value,
				state.getPostcode,
				visitorParameters.visitor_parameters.uuid
			);
			dispatch({
				type: 'getExtraAddressDetails',
				payload: { get_details: getData.data, manual_address: 'show' },
			});
			props.clearErrors([
				'address1',
				'txtHouseNumber',
				'txtAddress3',
				'txtCounty',
				'txtTown',
				'txtCountry',
			]);
			setTimeout(() => {
				scrollToEvent.current.scrollIntoView({
					behavior: 'smooth',
					block: 'end',
				});
			}, 50);
		} else {
			dispatch({
				type: 'getExtraAddressDetails',
				payload: { get_details: [], manual_address: 'hide' },
			});
		}
	};

	const lookupValidation = async (e) => {
		await props.trigger('txtPostCode');
	};

	const handlePostCode = async (e) => {
		let errorFlag = 0;
		const txtPostCode = await props.trigger('txtPostCode');
		var txtAddress;
		if (txtPostCode) {
			txtAddress = await props.trigger('address1');
		} else {
			document.getElementById('txtPostCode').focus();
			return false;
		}
		if (!txtAddress) {
			document.getElementById('address1').focus();
			return false;
		}
		if (!txtPostCode || !txtAddress) {
			errorFlag = 1;
		}
		if (errorFlag === 0) {
			GTMDataLayer({
					clickEvent: 'slideclick',
					question: 'postcode',
					answer: '',
				});
			props.slideChange(e);
		} else {
			return false;
		}
	};

	return (
		<div className={props.slideStatus}>
			<label class="mt-3 mb-3"  style={{fontSize:"18px",textAlign:"center"}} htmlFor="Date of Birt">Great! Let's Confirm that You Live in Qualifying Postcode</label>
			<div className="d-flex flex-column flex-md-row gap-2">
				{/* <div className="">
					<div className=""> */}
				<AddressTextField
					type="text"
					placeholder="Postcode"
					id="txtPostCode"
					className="form-control"
					dataId="txtPostCode"
					autoComplete="off"
					// onKeyDown={(e) => {
					//   if (e.key === ' ') e.preventDefault();
					// }}
					register={props.register('txtPostCode', {
						required: 'Please Enter Postcode',
						pattern: {
							value: /^[A-Za-z0-9 ]+$/,
							// value:
							// /^(([A-Z]\s*[A-Z]?\s*[0-9]\s*[0-9]?\s*[0-9]\s*[A-Z]\s*[A-Z])|([A-Z]\s*[A-Z]?\s*[0-9]\s*[A-Z]\s*[0-9]\s*[A-Z]\s*[A-Z]\s*[A-Z]?))$/i,
							message: 'Please Enter a Valid Postcode',
						},
						minLength: {
							value: 5,
							message: 'Please Enter a Valid Postcode',
						},
						onBlur: (e) => {
							e.target.value = e.target.value.trim();
							checkValidation(e);
						},
					})}
				// validationMsg={
				// 	props.validationMsg.txtPostCode &&
				// 	props.validationMsg.txtPostCode.message
				// }
				/>

				<Button
					type="button"
					className="a-lookup"
					value="Look Up Address"
					buttonText="Look Up Address"
					onClick={lookupValidation}
				/>



			</div>
			{props.validationMsg.txtPostCode && (
				<span className="error_msg">
					{props.validationMsg.txtPostCode.message}
				</span>
			)}

			{/* <div className="col-6 ms-1"> */}

			{/* </div> */}
			{/* </div>
				</div> */}
			<div
				id="currentAddressCollapse"
				style={state.checkSelect ? { display: 'block' } : { display: 'none' }}
			>
				<div className="col-lg-12 mb-3 mt-3">
					<AddressSelectBox
						className="form-select"
						OptionValue={state.getAddress}
						id="address1"
						register={props.register('address1', {
							required: 'Please select address',
							onChange: (e) => getValue(e),
						})}
						validationMsg={
							props.validationMsg.address1 &&
							props.validationMsg.address1.message
						}
					/>
				</div>

				<div className={`ADD_detail slide8_add row ${state.showManualAddress}`}>
					{state.getDetails?.line_1 && (
						<div
							className={`col-lg-12 mb-1 form-group required-field adj_width`}
						>
							<AddressTextField
								type="text"
								placeholder="Address Line 1 *"
								id="txtHouseNumber"
								className="form-control"
								dataId="txtHouseNumber"
								autoComplete="off"
								readonly={true}
								register={props.register('txtHouseNumber', {
									required: 'Please Enter Address Line 1',
								})}
								validationMsg={
									props.validationMsg.txtHouseNumber &&
									props.validationMsg.txtHouseNumber.message
								}
								value={state.getDetails.line_1}
							/>
						</div>
					)}
					{state.getDetails?.line_2 && (
						<div className={`col-lg-12 mb-1 form-group adj_width`}>
							<AddressTextField
								type="text"
								placeholder="Address Line 2"
								id="txtAddress2"
								className="form-control"
								dataId="txtAddress2"
								autoComplete="off"
								readonly={true}
								register={props.register('txtAddress2')}
								value={state.getDetails.line_2}
							/>
						</div>
					)}
					{state.getDetails?.line_3 && (
						<div className={`col-lg-12 mb-1 form-group adj_width`}>
							<AddressTextField
								type="text"
								placeholder="Address Line 3"
								id="txtAddress3"
								className="form-control"
								dataId="txtAddress3"
								autoComplete="off"
								readonly={true}
								register={props.register('txtAddress3')}
								validationMsg=""
								value={state.getDetails.line_3}
							/>
						</div>
					)}
					{state.getDetails?.line_4 && (
						<div className={`col-lg-12 mb-1 form-group adj_width`}>
							<AddressTextField
								type="text"
								placeholder="Address Line 4"
								id="txtAddress4"
								className="form-control"
								dataId="txtAddress4"
								autoComplete="off"
								readonly={true}
								register={props.register('txtAddress4')}
								validationMsg=""
								value={state.getDetails.line_4}
							/>
						</div>
					)}
					{state.getDetails?.county && (
						<div className={`col-lg-12 mb-1 form-group adj_width`}>
							<AddressTextField
								type="text"
								placeholder="County"
								id="txtCounty"
								className="form-control"
								dataId="txtCounty"
								autoComplete="off"
								readonly={true}
								register={props.register('txtCounty')}
								validationMsg=""
								value={state.getDetails.county}
							/>
						</div>
					)}
					{state.getDetails?.town && (
						<div className={`col-lg-12 mb-1 form-group adj_width`}>
							<AddressTextField
								type="text"
								placeholder="Town *"
								id="txtTown"
								className="form-control  hero-input"
								dataId="txtTown"
								autoComplete="off"
								readonly={true}
								register={props.register('txtTown', {
									required: 'Please Enter Town',
								})}
								validationMsg={
									props.validationMsg.txtTown &&
									props.validationMsg.txtTown.message
								}
								value={state.getDetails.town}
							/>
						</div>
					)}
					{state.getDetails?.country && (
						<div className={`col-lg-12 mb-1 form-group adj_width}`}>
							<AddressTextField
								type="text"
								placeholder="Country *"
								id="txtCountry"
								className="form-control  hero-input"
								dataId="txtCountry"
								autoComplete="off"
								readonly={true}
								register={props.register('txtCountry', {
									required: 'Please Enter Country',
								})}
								validationMsg={
									props.validationMsg.txtCountry &&
									props.validationMsg.txtCountry.message
								}
								value={state.getDetails.country}
							/>
						</div>
					)}
					{state.getDetails?.district && (
						<div className={` d-none col-lg-12 mb-1 form-group adj_width}`}>
							<AddressTextField
								type="text"
								placeholder="District *"
								id="txtDistrict"
								className="form-control  hero-input"
								dataId="txtDistrict"
								autoComplete="off"
								readonly={true}
								register={props.register('txtDistrict', {
									required: 'Please Enter Country',
								})}
								validationMsg={
									props.validationMsg.txtDistrict &&
									props.validationMsg.txtDistrict.message
								}
								value={state.getDetails.district}
							/>
						</div>
					)}
					<div
						className={`col-lg-12 mb-3 form-group adj_width}`}
						style={
							state.getDetails.locality
								? { display: 'block' }
								: { display: 'none' }
						}
					>
						<AddressTextField
							type="text"
							id="locality"
							className="form-control  hero-input"
							dataId="locality"
							autoComplete="off"
							readonly={true}
							register={props.register('locality', {
								required: 'Please Enter locality',
							})}
							value={state.getDetails.locality}
						/>
					</div>
				</div>
			</div>
			<button type="button" className="next-btn" name="next2" onClick={handlePostCode}>Next</button>
			<div ref={scrollToEvent}></div>
		</div>
	);
};

export default Postcode;